
import { useNavigate } from "react-router-dom";
import Footer from "../footer";
import RegisterVisual from "../Visual/registerVisual";
import { SubmitHandler, useForm } from "react-hook-form";

import config from '../../Api/config'
import { useSession } from "../sessionProvider";
import { DatabaseDppPagination, VariantItemEntry } from "../../Api/Database";
import ItemAccordion from "./itemAccordion";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import useLazyLoaderWSearch from "../../Api/lazyLoadingWSearch";


type FormInputs = {
    file: FileList, 
};

function MyDpps() {


    const navigate = useNavigate();
    const {
        status,
        error_reason,
        cookie,
        is_onboarded,
        ownerId
    } = useSession();
  
    const {register, handleSubmit, setError, formState: {errors}} = useForm<FormInputs>();

    const urlParams = new URLSearchParams(window.location.search);
    let searchParameter = urlParams.get('id');

    const {lazyLoadingRef, elements, end, loading, filterElement} = useLazyLoaderWSearch<VariantItemEntry, HTMLDivElement>({elementFetcher: (offset: string, limit: string) => {
        return config.API.getDpps(ownerId, limit, offset)
      
    }, elementFilter: (product: VariantItemEntry, value: string) => {
        if( product.id !== undefined){
            return (
                product.id.toLowerCase().includes(value.toLowerCase()) || // DPP ID
                product.variant_id.toLowerCase().includes(value.toLowerCase()) || // Variant ID
                product.variant_name.toLowerCase().includes(value.toLowerCase()) || // Variant name
                product.batch_number.toLowerCase().includes(value.toLowerCase()) || // Batch
                product.parent_name.toLowerCase().includes(value.toLowerCase())    // Product name
            );   
        }
        return false;
    }})

    //const [filteredProducts, setFilteredProducts] = useState<VariantItemEntry[]>(products);

    const handleSearchChange = (event: any) => {
        const value = event.target.value;
        filterElement(value);
    };

    useEffect (() =>{
        if(searchParameter){
            filterElement(searchParameter);
        }
    },[])

    return(<>
        <div className="company" ref={lazyLoadingRef}>

            <RegisterVisual title={"My DPP items"}/>

            <div className="explorer">

                <div>

                    <div className="filter filter-dpp">
                        <TextField
                            id="outlined-basic"
                            label="Search by product name or ID"
                            variant="outlined"
                            sx={{ width: "340px" }}
                            InputProps={{
                                endAdornment: (
                                <IconButton>
                                    <SearchIcon />
                                </IconButton>
                                ),
                            }}
                            defaultValue= {searchParameter ? searchParameter : ""}
                            onChange={handleSearchChange}
                        />
                    </div>

                    <div className="dpp_card_section">
                        {elements && elements.length > 0 ?
                        
                            elements.map((el, productIndex) => {
                                return(<ItemAccordion key={el.id} item={el} />)
                            })
                        : <>No DPP results. </>
                        }
                    </div>

                </div>

            </div>

            <Footer/>
        </div>
    </>)
}

export default MyDpps;
